import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27899bf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "acExpansionPanel" }
const _hoisted_2 = { class: "acExpansionPanel_title__icon" }
const _hoisted_3 = { class: "acExpansionPanel_text__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "acExpansionPanel_title",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePanel && _ctx.togglePanel(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.panel[_ctx.fields.title]) + " ", 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          class: _normalizeClass(`icon icon-${_ctx.icon}`)
        }, null, 2)
      ])
    ]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["acExpansionPanel_text", {
          '-isClosePanel': _ctx.isClosePanel
        }])
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.panel[_ctx.fields.text]), 1)
        ], 2)
      ]),
      _: 1
    })
  ]))
}